import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-3">
            焦点专题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热播专题精选
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精心策划的追剧专题，发现更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <a
              key={item.id}
              href={item.link}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector(item.link)?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer block"
            >
              <div className="aspect-[5/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-block text-xs font-medium text-accent-300 bg-accent-500/30 px-2 py-0.5 rounded mb-2">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-bold text-white font-heading mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-background-200/80 line-clamp-2">
                  {item.subtitle}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}